import PropTypes from 'prop-types'
import { List, ListItem, ListItemText } from 'ui-components-web'
import Popover from '@material-ui/core/Popover'

import Modals from 'singletons/Modals'

const AvailabilityPopover = ({ id, open, anchorEl, handleClosePopover }) => {
  const handleSetAvailabilityClick = () => {
    Modals.open('setAvailability')
  }

  const handleBlackoutDatesClick = () => {
    Modals.open('blackoutDates')
  }

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClosePopover}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <List component="nav">
        <ListItem onClick={handleBlackoutDatesClick} button>
          <ListItemText primary={'Blackout Dates'} />
        </ListItem>
        <ListItem onClick={handleSetAvailabilityClick} button>
          <ListItemText primary={'Set Availability'} />
        </ListItem>
      </List>
    </Popover>
  )
}
AvailabilityPopover.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  handleClosePopover: PropTypes.func.isRequired,
}
AvailabilityPopover.defaultProps = {
  id: undefined,
  anchorEl: null,
}

export default AvailabilityPopover
